export default __webpack_public_path__ + "static/media/certificate_python_hackerrank.54832d7f.WebP";